import { Input, InputProps } from '@lfg/ui/components';
import { Stack, Typography } from '@mui/material';
import { forwardRef } from 'react';

import CheckIcon from 'src/assets/icons/check-circle.svg';
import { colors } from 'src/global/styles/colors';

export interface AdminInputProps extends InputProps {
  placeholder?: string;
  isError?: boolean;
  errorMsg?: string;
  inputHeight?: string;
  inputPd?: string | number;
  isSuccess?: boolean;
  successMsg?: string;
}

export const AdminInput = forwardRef(
  (props: AdminInputProps, ref: React.Ref<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      placeholder,
      isError = false,
      errorMsg,
      isSuccess = false,
      successMsg,
      inputHeight = '48px',
      inputPd = '14px 16px',
      onChange,
      onBlur,
      sx,
      ...rest
    } = props;

    return (
      <Stack width={'100%'}>
        <Input
          ref={ref}
          sx={{
            width: '100% !important',
            '& .MuiInputBase-input.Mui-readOnly': {
              cursor: 'not-allowed',
            },
            ...sx,
          }}
          isFullWidth
          inputPd={inputPd}
          inputHeight={inputHeight}
          borderColor={isError ? colors.error : colors.neutral015}
          placeholder={placeholder}
          onBlur={e => {
            const trimmedValue = e.target.value.trim();
            if (trimmedValue !== e.target.value && onChange) {
              onChange({
                ...e,
                target: { ...e.target, value: trimmedValue },
              });
            }
            onBlur && onBlur(e);
          }}
          onChange={onChange}
          {...rest}
        />
        {isError ? (
          <Typography paddingTop={1} color={colors.error} fontSize={'14px'}>
            {errorMsg}
          </Typography>
        ) : null}
        {isSuccess ?? (
          <Stack direction={'row'} alignItems={'center'} gap={0.5} paddingTop={1}>
            <CheckIcon />
            <Typography color={colors.green300} fontSize={'14px'}>
              {successMsg}
            </Typography>
          </Stack>
        )}
      </Stack>
    );
  },
);
